import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageModule from './ImageModule';
import SubHead from '../SubHead/SubHead';
import BodyText from '../BodyText/BodyText';
import { isValid, isText } from '../../../../utils';

class MultipleImages extends Component {
  render() {
    const {
      data,
      className,
      isMobile,
      fullUrl,
      articleLayout,
      isAffiliate,
      seo,
    } = this.props;
    if (!isValid(data)) { return null; }
    const { hed, hedBody } = data;
    const imagesData = isValid(data.data) ? data.data : [];
    const numArticles = imagesData.length;
    const width = (imagesData.length > 2 && articleLayout === 'Standard') ? 'slim' : 'regular';

    const renderedImages = imagesData.map((image, i) => (
      <ImageModule
        key={i}
        data={image}
        className="multi-image"
        isMobile={isMobile}
        fullUrl={fullUrl}
        numArticles={numArticles}
        isAffiliate={isAffiliate}
        articleLayout={articleLayout}
        seo={seo}
      />
    ));

    const multi = isMobile ? 'row-1x' : 'row-3x';


    return (
      <Fragment>
      <SubHead className='sub-head module-hed' data={hed} />
      {(isText(hedBody)) && 
        <BodyText className='multi-image-row-body-text header-body' data={hedBody} isAffiliate={isAffiliate}/>
      }
      <div className="multi-image-container-wrapper">
        <div className={`${className}-wrapper ${multi} ${width}`}>
          {renderedImages}
        </div>
      </div>
      </Fragment>
    );
  }
}

MultipleImages.propTypes = {
  data: PropTypes.array,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default MultipleImages;
